import { client } from '@/client';
import { MessageResponseModel } from '@/client/models';
import { OSINT_TRANSPARENCY_QUERY_KEY } from '@/hooks/query/osint-transparency.hooks';
import { GenericForbiddenApiError } from '@/hooks/query/types';
import { useMutation, useQueryClient } from 'react-query';

export const useAcceptDpaAmendment = (
  accountId: string,
): {
  acceptDpa: () => Promise<MessageResponseModel>;
  isLoading: boolean;
} => {
  const queryClient = useQueryClient();

  const { mutateAsync, ...rest } = useMutation<
    MessageResponseModel,
    GenericForbiddenApiError,
    void
  >('accept-dpa-amendment', () => client.accountOsint.acceptDpa(accountId), {
    onSuccess: () => {
      queryClient.invalidateQueries(['account', accountId]);
      queryClient.invalidateQueries([OSINT_TRANSPARENCY_QUERY_KEY, accountId]);
    },
  });

  return { acceptDpa: mutateAsync, isLoading: rest.isLoading };
};

export const useWithdrawDpaAmendment = (
  accountId: string,
): {
  withdrawDpa: () => Promise<MessageResponseModel>;
  isLoading: boolean;
} => {
  const queryClient = useQueryClient();

  const { mutateAsync, ...rest } = useMutation<
    MessageResponseModel,
    GenericForbiddenApiError,
    void
  >(
    'withdraw-dpa-amendment',
    () => client.accountOsint.withdrawDpa(accountId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['account', accountId]);
        queryClient.invalidateQueries([
          OSINT_TRANSPARENCY_QUERY_KEY,
          accountId,
        ]);
      },
    },
  );

  return { withdrawDpa: mutateAsync, isLoading: rest.isLoading };
};
